import { FeatureMessagesUI } from "./FeatureMessagesUI";
import { StandardProps } from "../componentMap";

export function FeatureMessages({ product }: Pick<StandardProps, "product">) {
  const { messaging: messages = [] } = product;

  const featureMessages = messages.filter(
    (message) =>
      message.type === "feature" && message.title === "60 Night Comfort Trial",
  );

  const updatedFeatureMessages = featureMessages.map((message) => {
    const messageDescription = message.description || null;
    const updatedLinksDescription =
      updateLinksToOpenInNewTabs(messageDescription);
    const [description, terms] = updatedLinksDescription.split(
      "<strong>Terms and conditions</strong>",
    );
    return {
      description,
      updatedLinksDescription,
      terms,
    };
  });

  return <FeatureMessagesUI featureMessages={updatedFeatureMessages} />;
}

export const updateLinksToOpenInNewTabs = (html: string | null) => {
  if (!html) return "";

  let newHtml = html;

  const regexp = /<a[^>]*>([^<]+)<\/a>/g;

  let match: string[] | null = null;

  const matches: string[][] = [];

  while ((match = regexp.exec(html))) {
    matches.push(match);
  }

  matches.forEach((match) => {
    let updatedLink = match[0] ?? "";
    updatedLink = addAttributeToLink(updatedLink, "rel", "noopener noreferrer");
    updatedLink = addAttributeToLink(updatedLink, "target", "_blank");
    updatedLink = addAttributeToLink(updatedLink, "class", "new-tab-link");
    if (match[0]) {
      newHtml = html.replace(match[0], updatedLink);
    }
  });

  return newHtml;
};

function addAttributeToLink(
  input: string,
  attributeName: string,
  attributeValue: string,
) {
  if (input.indexOf(`${attributeName}="${attributeValue}"`) < 0) {
    input = input.replace("<a", `<a ${attributeName}="${attributeValue}"`);
  }
  return input;
}
